export const firebaseConfig = {
  apiKey: "AIzaSyDgdu5_gt8unUPB1sNzM1M4r5OqS5Q5-1g",
  authDomain: "movie-app-2f6bf.firebaseapp.com",
  projectId: "movie-app-2f6bf",
  storageBucket: "movie-app-2f6bf.appspot.com",
  messagingSenderId: "1074280876139",
  appId: "1:1074280876139:web:dd92fea9e7934786d7c92e",
  measurementId: "G-ZTE442HJJM",
};
